export const canManageAccessAndPermissions = ({ currentMemberData, filespaceId, }) => {
    const { filespaceAdminFor, privileges } = currentMemberData || {};
    const doesManageAtLeastOneFilespace = filespaceAdminFor === 'all' ||
        // If there's a filespace that the user does manage it'll have a truthy value
        // filespaceAdminFor format is currently {[fsId]: true} or 'all'
        Object.values(filespaceAdminFor || {}).some((managesFilespace) => managesFilespace === true);
    const hasRequiredPrivileges = Boolean(privileges?.canAdminFilespaces &&
        (privileges?.groupsRead || privileges?.membersUpdate));
    return Boolean(filespaceId
        ? (filespaceAdminFor === 'all' ||
            filespaceAdminFor?.[filespaceId]) &&
            hasRequiredPrivileges
        : hasRequiredPrivileges && doesManageAtLeastOneFilespace);
};
